import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const LCM = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>LCM</h1>
        <p>Find the Least Common Multiple of two numbers with this Python project.</p>
        <ImageWithFallback src="/LCM_2.png" alt="LCM" className="hero-image" />
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project calculates the Least Common Multiple (LCM) of two numbers using Python.</p>
        <h2>Download</h2>
        <a href="/LCM.py" download>Download LCM.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file and input two numbers to find their LCM.</p>
      </div>
    </div>
  );
};

export default LCM;
